import React, { useEffect, useState } from "react";

const BlockModal = ({ blockMethod, id, fullName, blocked }) => {
  const [block, setBlock] = useState(blocked);
  useEffect(() => {
    if (blocked) {
      setBlock(false);
    } else {
      setBlock(true);
    }
  }, [blocked]);

  return (
    <div className="modal fade" id="block-modal" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div>
            <h4 className="text-center mb-4">
              User will be {blocked ? "unblocked" : "blocked"}{" "}
            </h4>
            <p className="text-center text-small">
              Please confirm your action.
            </p>
            <div className="text-center mt-4">
              <button
                type="button"
                className="btn btn-main"
                data-dismiss="modal"
                onClick={() =>
                  blockMethod.mutate({
                    id: id,
                    blocked: block,
                  })
                }
              >
                {blocked ? "Unblock" : "Block"}
              </button>
              <button
                type="button"
                className="btn btn-sm btn-cancel"
                data-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

BlockModal.propTypes = {};

export default BlockModal;
